var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-center-detail" },
    [
      _c(
        "a-modal",
        {
          attrs: { centered: "", width: 884, title: _vm.appDetail.name },
          on: { cancel: _vm.hideModal },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return undefined
              },
              proxy: true,
            },
          ]),
          model: {
            value: _vm.visible,
            callback: function ($$v) {
              _vm.visible = $$v
            },
            expression: "visible",
          },
        },
        [
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _c("a-icon", {
                staticStyle: { "font-size": "24px" },
                attrs: { slot: "indicator", type: "loading", spin: "" },
                slot: "indicator",
              }),
              _c("div", { staticClass: "content" }, [
                _c("div", { staticClass: "desc" }, [
                  _vm._v(_vm._s(_vm.appDetail.description)),
                ]),
                _c(
                  "div",
                  { staticClass: "app-pics flex-side-center" },
                  _vm._l(_vm.appSeries, function (series, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass:
                          "app-pic-item flex-column flex-side-center flex-auto",
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: series.imageUrl,
                            alt: series.imageName,
                          },
                        }),
                        _c("span", { staticClass: "text" }, [
                          _vm._v(_vm._s(series.imageName)),
                        ]),
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "trigger-action" },
                  [
                    _c(
                      "a-tabs",
                      {
                        attrs: {
                          animated: false,
                          tabBarGutter: 32,
                          tabBarStyle: _vm.tabBarStyle,
                        },
                        model: {
                          value: _vm.tabKey,
                          callback: function ($$v) {
                            _vm.tabKey = $$v
                          },
                          expression: "tabKey",
                        },
                      },
                      _vm._l(_vm.tabs, function (tab) {
                        return _c(
                          "a-tab-pane",
                          { key: tab.key, attrs: { tab: tab.name } },
                          [
                            _c(
                              "div",
                              { staticClass: "section" },
                              [
                                _vm.triggerOrActions(tab.key).length
                                  ? _vm._l(
                                      _vm.triggerOrActions(tab.key),
                                      function (item, idx) {
                                        return _c(
                                          "div",
                                          {
                                            key: idx,
                                            staticClass:
                                              "tab-item flex-column flex-main-between",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "title" },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                            _c("div", { staticClass: "desc" }, [
                                              _vm._v(_vm._s(item.description)),
                                            ]),
                                          ]
                                        )
                                      }
                                    )
                                  : [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "flex-center",
                                          staticStyle: { height: "200px" },
                                        },
                                        [
                                          _c("a-empty", {
                                            attrs: {
                                              image:
                                                _vm.Empty
                                                  .PRESENTED_IMAGE_SIMPLE,
                                              description: "暂无数据",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }